import { Component } from '@angular/core';

@Component({
  selector: 'balanza-comprobacion-Cuenta',
  styles: [],
  templateUrl: 'balanzaComprobacion.component.html'
})

export class BalanzaComprobacionComponent {}


// WEBPACK FOOTER //
// ./src/app/Contabilidad/balanzaComprobacion/balanzaComprobacion.component.ts